/**
 * @generated SignedSource<<b8ee6c2cc4010fde6d5acdd2a0507750>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserGuildMembershipsOrganizersSection_user$data = {
  readonly id: string;
  readonly organizingGuilds: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string | null | undefined;
      readonly node: {
        readonly guild: {
          readonly " $fragmentSpreads": FragmentRefs<"GuildCardNew_guild">;
        } | null | undefined;
      } | null | undefined;
    }>;
  };
  readonly " $fragmentType": "UserGuildMembershipsOrganizersSection_user";
};
export type UserGuildMembershipsOrganizersSection_user$key = {
  readonly " $data"?: UserGuildMembershipsOrganizersSection_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserGuildMembershipsOrganizersSection_user">;
};

import UserGuildMembershipsOrganizersSectionPaginationQuery_graphql from './UserGuildMembershipsOrganizersSectionPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "organizingGuilds"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 6,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": UserGuildMembershipsOrganizersSectionPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "UserGuildMembershipsOrganizersSection_user",
  "selections": [
    {
      "alias": "organizingGuilds",
      "args": [
        {
          "kind": "Literal",
          "name": "condition",
          "value": {
            "membershipLevel": "ORGANIZER"
          }
        }
      ],
      "concreteType": "GuildMembershipsConnection",
      "kind": "LinkedField",
      "name": "__UserGuildMembershipsOrganizersSection_user_organizingGuilds_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GuildMembershipsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GuildMembership",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Guild",
                  "kind": "LinkedField",
                  "name": "guild",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "GuildCardNew_guild"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "__UserGuildMembershipsOrganizersSection_user_organizingGuilds_connection(condition:{\"membershipLevel\":\"ORGANIZER\"})"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "559a0ab95ce30e30d4e580383179e6fe";

export default node;
